import { useCallback } from "react";

import { spinnerOverlay } from "../overlays/spinner";

export const useSpinnerOverlay = (id: string) => {
  const open = useCallback(() => {
    spinnerOverlay.open(id, {});
  }, [id]);
  const close = useCallback(() => {
    spinnerOverlay.close(id, {});
  }, [id]);

  return { close, open };
};
